import React from "react";
import first from "../assets/images/LowDamage/1.gif";
import second from "../assets/images/LowDamage/2.png";
import ResponsiveEmbed from "react-responsive-embed";

const Index = props => {
  return (
      <div className="c-content-box">
        <h2>Low Damage Design</h2>
          <div style={{ textAlign: 'justify', lineHeight: '2em'}}>

          <img src={first} style={{ width: '100%', height: '100%' }} />

          Citing the words in the PRESS Design handbook (Pampanin et al., 2010): “Major advances have been observed in the last decade in seismic engineering with further refinements of performance-based seismic design philosophies and the definition of corresponding compliance criteria. Following the worldwide recognized expectation and ideal aim to provide a modern society with high (seismic) performance structures able to sustain a design level earthquake with limited or negligible damage, emerging solutions have been developed for high-performance, still cost-effective, seismic resisting systems, based on adequate combination of traditional materials and available technology.” <br /> <br />

          <h3>The PRESSS system</h3>
          “One of those is the PREcast Seismic Structural System (PRESSS), developed at the University of California, San Diego (Priestley, 1991, 1996; Priestley et al. 1999). In this system, precast elements are jointed together through unbonded post-tensioning tendons/strands or bars. The inelastic demand is accommodated within the connection itself (beam-column, column to foundation or wall-to-foundation critical interface), through the opening and closing of an existing gap (rocking motion) while reduced level of damage, when compared to equivalent cast-in-place solutions.” <br /> <br />

          <img src={second} style={{ width: '100%', height: '100%' }} />

          <h3>My experience</h3>
          I had the incredible opportunity to learn how to design such kind of structures in a course at the ROSE school in Pavia, called “Seismic Design of Low-Damage Concrete and Timber Buildings” by professor Stefano Pampanin. <br /> <br />
          <ResponsiveEmbed src='https://www.youtube.com/embed/X9vDWHWCoik' allowFullScreen />
          <ResponsiveEmbed src='https://www.youtube.com/embed/xazfxid0DAE' allowFullScreen />




        </div>
      </div>
  );
};

export default Index;



// WEBPACK FOOTER //
// ./src/pages/lowdamage.en.jsx